import { render, staticRenderFns } from "./PageMath.vue?vue&type=template&id=5e76927e&scoped=true&"
import script from "./PageMath.vue?vue&type=script&lang=js&"
export * from "./PageMath.vue?vue&type=script&lang=js&"
import style0 from "./PageMath.vue?vue&type=style&index=0&id=5e76927e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e76927e",
  null
  
)

export default component.exports